<template>
<v-card>
<v-container fluid>
<v-card>
<form ref="form"
v-model="valid"
lazy-validation>
    <v-row>
    <v-col cols="12" sm="6" md="3">
        <v-menu v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="editedItem.start_dt"
                label="Fecha de Emisión Desde"
                prepend-icon="mdi-calendar-today"
                :rules="fechaRule"
                readonly
                required
                v-bind="attrs"
                v-on="on"
                ></v-text-field>
        </template>
        <v-date-picker v-model="editedItem.start_dt" @input="menu = false"></v-date-picker>
        </v-menu>
    </v-col>
    <v-col cols="12" sm="6" md="3">
        <v-menu v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="editedItem.end_dt"
                label="Fecha de Emisión Hasta"
                prepend-icon="mdi-calendar-today"
                :rules="fechaRule"
                readonly
                required
                v-bind="attrs"
                v-on="on"
                ></v-text-field>
        </template>
        <v-date-picker v-model="editedItem.end_dt" @input="menu2 = false"></v-date-picker>
        </v-menu>
    </v-col>  
    <v-col cols="12" sm="6" md="3">
        <v-autocomplete v-model="editedItem.ApiPunto"
        :items="oppoint"
        :item-text="'OpPoint_Description'"
        :item-value="'OpPoint_id'"
        label="Centro"
        multiple
        ></v-autocomplete>
     </v-col>
     <v-col cols="12" sm="6" md="3">
     </v-col>
     <v-col cols="12" sm="6" md="3">
        <v-container>
            <v-btn :disabled="btn" color="primary" @click="submit">Generar Reporte de OC sin Turno</v-btn>
        </v-container>
      </v-col>
    </v-row>
  </form>
  <v-spacer></v-spacer>
  </v-card>
  </v-container>
  <v-container fluid>
    <v-card>
     <v-card-title>
       <v-icon x-large>mdi-clipboard-list-outline</v-icon>OC Sin Turno
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="mvm"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
  <template v-slot:item.action="{ item }">
    <v-tooltip bottom>
     <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        class="mr-2"
        v-bind="attrs"
        v-on="on"
        @click="viw_detail(item)"
      >
        mdi-eye
      </v-icon>
      </template>
      <span>Ver Detalle</span>
      </v-tooltip>
    </template>
  </v-data-table>
  </v-card>
  </v-container>
  <v-spacer></v-spacer>
<template>
<div class="text-center">
    <v-btn type="button" color="primary" @click="onexport">Descargar OC Sin Turno</v-btn>
</div>
</template>
  <v-dialog v-model="dialog_detail" max-width="1000px">
  <v-card>
            <v-card-title>
              <span class="headline">Detalle</span>
            </v-card-title>

            <v-card-text>
              <v-container>
              <v-row>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.TurningStorageArea_Desc"
                        label="Almacen"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.OpPoint_id"
                        label="Punto"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.VendorPurchaseOrder_Num"
                        label="OC"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.Section_Description"
                        label="Sección"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field :disabled="true" type="text" v-model="this.Supplier_Description"
                        label="Proveedor"  required></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.RequestProposal_Dt"
                        label="Fecha Emisión"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.Reception_Dt"
                        label="Fecha Entrega"  required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field :disabled="true" type="text" v-model="this.Closing_Dt"
                        label="Fecha Cierre"  required></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field :disabled="true" type="text" v-model="this.CHour_Description"
                        label="Hora de Entrega"  required></v-text-field>
                    </v-col>
                </v-row>
  <v-data-table
    :headers="headers2"
    :items="tdetalle_vew"
    :search="search2"
    sort-by="ProductBarCode_id"
    class="elevation-1"
  >
  </v-data-table>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close2">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
  </v-dialog>
  <v-dialog v-model="dialog_new" max-width="900px">
  <v-stepper v-model="e1" vertical>
         <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
        <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Buscando Pedidos
            <small>Consultando Pedidos sin Turnos </small>
        </v-stepper-step>
        <v-stepper-content step="1">
        <v-card height="100px">
            <div class="text-center">
            <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
            {{this.msj_proceso}}
            </div>
        </v-card>
        </v-stepper-content>

        <v-stepper-step :complete="e1 > 2" step="2" :rules="[value => !! step_error2]" :color="step_color2">Buscando Referencias
            <small>Consultando detalle de los Pedidos sin Turnos </small>
        </v-stepper-step>
        <v-stepper-content step="2">
        <v-card height="100px">
            <div class="text-center">
            <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
            {{this.msj_proceso}}
            </div>
        </v-card>
        </v-stepper-content>
        
    </v-stepper>
  </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'
//import Vue from "vue";
//import JsonExcel from "vue-json-excel";
import XLSX from 'xlsx';
 
//Vue.component("downloadExcel", JsonExcel);

export default {
  data: () => ({
    search: '',
    search2: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    dialog_detail: false,
    valid: true,
    menu: false,
    menu2: false,
    e1: 0,
    btn: false,
    msj_proceso:'',
    progressBar1: false,
    progressBar: false,
    overlay: false,
    step_error1: true,
    step_error2: true,
    step_error3: true,
    step_color1:"primary",
    step_color2:"primary",
    step_color3:"primary",
    TurningStorageArea_Desc:'',
    OpPoint_id: '',
    Supplier_Description:'',
    VendorPurchaseOrder_Num:'',
    Section_Description:'',
    RequestProposal_Dt: '',
    Reception_Dt: '',
    Closing_Dt:'',
    Comment_Txt:'',
    CDay_id:'',
    CHour_Description:'',
    
    headers: [
      { text: 'Actions', value: 'action', sortable: false },
      { text: 'Prop. Pedido Id', value: 'RequestProposal_id'},
      { text: 'OC', value: 'VendorPurchaseOrder_Num' },
      { text: 'Punto', value: 'OpPoint_id' },
      { text: 'AlmacenID', value: 'TurningStorageArea_id' },
      { text: 'Almacén', value: 'TurningStorageArea_Desc' },
      { text: 'Prov', value: 'Supplier_id' },
      { text: 'R Social', value: 'Supplier_Description' },
      { text: 'SeccionID', value: 'Section_id'},
      { text: 'Sección', value: 'Section_Description'},
      { text: 'Status', value: 'status'},
      { text: 'Tipo Movimiento', value: 'tipo_movimiento'},
      { text: 'Cantidad en Bultos', value: 'BU_Qty'},
      { text: 'Cantidad en Pallet', value: 'PA_Qty'},
      { text: 'Cantidad de lineas', value: 'Turn_Qty'},
      { text: 'Fecha Emisión', value: 'RequestProposal_Dt'},
      { text: 'Fecha Entrega', value: 'Reception_Dt' },
      { text: 'Hora De Entrega', value: 'CHour_Description' },
      { text: 'Observación', value: 'Comment1_Txt' },
      { text: 'Usuario', value: 'LastOpRepUser_id'}
      
    ],
    headers2: [
      { text: 'Prop. Pedido Id', value: 'RequestProposal_id'},
      { text: 'Num. Linea', value: 'RequestProposalLine_id' },
      { text: 'OC', value: 'VendorPurchaseOrder_Num' },
      { text: 'Punto', value: 'OpPoint_id' },
      { text: 'AlmacenID', value: 'TurningStorageArea_id' },
      { text: 'Almacén', value: 'TurningStorageArea_Desc' },
      { text: 'Prov', value: 'Supplier_id' },
      { text: 'R Social', value: 'Supplier_Description' },
      { text: 'SeccionID', value: 'Section_id'},
      { text: 'Sección', value: 'Section_Description'},
      { text: 'Status', value: 'status'},
      { text: 'Tipo Movimiento', value: 'tipo_movimiento'},
      { text: 'Ean', value: 'ProductBarCode_id' },
      { text: 'Desc', value: 'ProductBarCode_Description' },
      { text: 'Unidad de Medida', value:'ReceptionHandlingUnit_id'},
      { text: 'Unidad de Medida desc', value:'ReceptionHandlingUnit_Desc'},
      { text: 'Cantidad en Bultos', value: 'BU_Qty'},
      { text: 'Cantidad en Pallet', value: 'PA_Qty'},
      { text: 'Cantidad Unidades', value: 'Turn_Qty'},
      { text: 'Fecha Emisión', value: 'RequestProposal_Dt'},
      { text: 'Fecha Entrega', value: 'Reception_Dt' },
     { text: 'Hora De Entrega', value: 'CHour_Description' }
     
    ],
    mvm: [],
    tdetalle: [],
    oppoint: [{ OpPoint_id: '', OpPoint_Description: '-Todos' }],
    tdetalle_vew: [],
    editedIndex: -1,
    editedItem: {
      start_dt: new Date().toISOString().substr(0, 10),
      end_dt: new Date().toISOString().substr(0, 10),
      ApiPunto: ''
      
    },
    defaultItem: {
      start_dt: new Date().toISOString().substr(0, 10),
      
    },
    fechaRule: [
        v => !!v || 'Fecha es requerida'
    ],
    
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      /* axios.post(this.api_tool_url + '/get_planning', this.editedItem, this.config)
        .then(response => {
            this.mvm = response.data.ResultRows
             if(response.data.ResultRows.length >= 1)
             {
                 axios.post(this.api_tool_url + '/get_planning_detail', this.editedItem, this.config)
                    .then(response => {
                        this.tdetalle = response.data.ResultRows
                    })
                    .catch(error => {
                        this.tdetalle = []
                        alert(error.response.data.message)
                    })
             }
        })
        .catch(error => {
          this.mvm = []
          alert(error.response.data.message)
        }), */
      
        axios.post(this.api_tool_url + '/get_oppoint_P', {}, this.config)
        .then(response => {
            this.oppoint = response.data.ResultRows
            this.oppoint.push({ OpPoint_id: '', OpPoint_Description: '-Todos' })
        })
        .catch(error => {
          this.oppoint = []
          alert(error.response.data.message)
        })

        
    },
    viw_detail(item){
      const index = this.mvm.indexOf(item)
      let tmpmvm = item
      this.dialog_detail=true
      this.progressBar1=true
      this.TurningStorageArea_Desc = tmpmvm.TurningStorageArea_Desc
      this.OpPoint_id = tmpmvm.OpPoint_id
      this.Supplier_Description = tmpmvm.Supplier_Description
      this.VendorPurchaseOrder_Num = tmpmvm.VendorPurchaseOrder_Num
      this.Section_Description = tmpmvm.Section_Description
      this.RequestProposal_Dt = tmpmvm.RequestProposal_Dt
      this.Reception_Dt = tmpmvm.Reception_Dt
      this.Closing_Dt = tmpmvm.Closing_Dt
      this.CHour_Description = tmpmvm.CHour_Description
      this.tdetalle_vew=[]
      
      this.tdetalle_vew = this.tdetalle.filter(function(item) {
        return item.RequestProposal_id == tmpmvm.RequestProposal_id
      })
    },
    submit () {
      this.btn = true
      this.dialog_new = true
      this.e1 = 1
      this.progressBar = true
      this.step_error1= true
      this.step_error2= true
      this.step_error3= true
      this.step_color1="primary",
      this.step_color2="primary",
      this.step_color3="primary",
      this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
      axios.post(this.api_tool_url + '/get_OCsinTurnos', this.editedItem, this.config)
          .then(response => {
            
            if(response.data.ResultRows.length >= 1)
            {
                this.mvm = response.data.ResultRows
                this.e1 = 2
                this.step_color1 = "#008000"
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                axios.post(this.api_tool_url + '/get_OCsinTurnos_Detail', this.editedItem, this.config)
                .then(response => {
                    if(response.data.ResultRows.length >= 1)
                    {
                        this.e1 = 3
                        this.step_color2 = "#008000"
                        this.tdetalle = response.data.ResultRows
                    }
                    else{
                        this.progressBar = false
                        this.msj_proceso = "No se encontro detalle."
                        this.step_error2 = false
                        this.step_error3 = false
                    }
                })
                .catch(error => {
                    this.td = []
                    this.btn = false
                    this.step_error2 = false
                    this.progressBar = false
                    this.msj_proceso = error.response.data.message
                })
            }
            else{
                this.progressBar = false
                this.msj_proceso = "No se encontrarón turnos."
                this.step_error1 = false
                this.step_error2 = false
                this.step_error3 = false
            }
            this.btn = false
          })
          .catch(error => {
            this.mvm = []
            this.btn = false
            this.step_error1 = false
            this.progressBar = false
            this.msj_proceso = error.response.data.message
          })
    },

    close () {
      this.dialog_new = false
    },
    close2 () {
      this.dialog_detail= false
    },

    onexport () { // On Click Excel download button
    
      // export json to Worksheet of Excel
      // only array possible
      const header_r_f = ['Prop. Pedido id','OC','Punto','Almacen Id','Almacen','Prov','R Social','SeccionID','Seccion','Status','Tipo Movimiento','Cantidad en Bultos','Cantidad en Pallet','Cantidad de lineas','Fecha Emisión','Fecha Entrega','Hora De Entrega','Observación','Usuario'];
      const header_r = ['RequestProposal_id','VendorPurchaseOrder_Num','OpPoint_id','TurningStorageArea_id','TurningStorageArea_Desc','Supplier_id','Supplier_Description','Section_id','Section_Description','status','tipo_movimiento','BU_Qty','PA_Qty','Turn_Qty','RequestProposal_Dt','Reception_Dt','CHour_Description','Comment1_Txt','LastOpRepUser_id',];
      var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
    
      const header_d_f = ['Prop. Pedido id','Num. Linea','OC','Punto','Almacen Id','Almacen','Prov','R Social','SeccionID','Seccion','Status','Tipo Movimiento','Ean','Desc','Unidad de Medida','Unidad de Medida desc','Cantidad en Bultos','Cantidad en Pallet','Cantidad Unidades','Fecha Emisión','Fecha Entrega','Hora De Entrega'];
      const header_d = ['RequestProposal_id','RequestProposalLine_id','VendorPurchaseOrder_Num','OpPoint_id','TurningStorageArea_id','TurningStorageArea_Desc','Supplier_id','Supplier_Description','Section_id','Section_Description','status','tipo_movimiento','ProductBarCode_id','ProductBarCode_Description','ReceptionHandlingUnit_id','ReceptionHandlingUnit_Desc','BU_Qty','PA_Qty','Turn_Qty','RequestProposal_Dt','Reception_Dt','CHour_Description'];
      var detalleWS = XLSX.utils.json_to_sheet(this.tdetalle, {header: header_d}) 

      var range = XLSX.utils.decode_range(resumenWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        resumenWS[colum].v = header_r_f[C];
      }

      range.e['c'] = header_r_f.length - 1;
      resumenWS['!ref'] = XLSX.utils.encode_range(range);

      var range = XLSX.utils.decode_range(detalleWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        detalleWS[colum].v = header_d_f[C];
      }

      range.e['c'] = header_d_f.length - 1;
      detalleWS['!ref'] = XLSX.utils.encode_range(range);

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
      
      var file='Reporte_OC_sin_Turno'+this.editedItem.start_dt+'.xlsx';

      // export Excel file
      XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestProposalNoTurnGrid.vue